import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import axios from "../../../../../../../../Global/axios";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../../../store/userSlice";
import { setArrayValues } from "../../candidateListFunctions";
// import { statusArray } from "./candidateListFunctions";

export default function EditUpdatedVisaCandidate({
  showPromptElement,
  setShowPromptElement,
  candidateListData,
  projectId,
  setCandidateListData,
  updateVisaDetails,
  ResetFilter,
}) {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [sector, setSector] = useState("");
  const [nationality, setNationality] = useState("");
  const [religion, setReligion] = useState("");
  const [date, setDate] = useState("");
  const [remark, setRemark] = useState("");
  const [actualPosition, setActualPosition] = useState("");
  const [dob, setDob] = useState("");
  const [age, setAge] = useState("");
  const [grade, setGrade] = useState("");
  const [basic, setBasic] = useState("");
  const [food, setFood] = useState("");
  const [fixedOt, setFixedOt] = useState("");
  const [hra, setHra] = useState("");
  const [travelAllowance, setTravelAllowance] = useState("");
  const [mobileAllowance, setMobileAllowance] = useState("");
  const [airTicketAllowance, setAirTicketAllowance] = useState("");
  const [additonalOt, setAdditonalOt] = useState("");
  const [OtherAllowance, setOtherAllowance] = useState("");
  const [dutyHours, setDutyHours] = useState("");
  const [fixedOtHours, setFixedOtHours] = useState("");
  const [contractDuration, setContractDuration] = useState("");
  const [ProbationPeriod, setProbationPeriod] = useState("");
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [emergencyContactPerson, setEmergencyContactPerson] = useState("");
  const [emergencyContactNumber, setEmergencyContactNumber] = useState("");
  const [covidVaccine, setCovidVaccine] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [VisaBlockNumber, setVisaBlockNumber] = useState("");
  const [VisaRefferenceNumber, setVisaRefferenceNumber] = useState("");
  const [uniequVisaBlock,setUniqueVisaBlock] = useState()
  const [VisaRefferenceNumberValidation, setVisaRefferenceNumberValidation] =
    useState("");
  const [changedValues, setChangedValues] = useState({
    id: showPromptElement?.id,
  });
  const [comments, setComments] = useState();
  function formatDate(inputDate) {
    // Create a mapping of month abbreviations to their numerical equivalents
    let value = String(inputDate);
    const monthMap = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    // Split the input date into parts
    const parts = value.split("-");

    // Map the abbreviated month to its numerical equivalent
    const month = monthMap[parts[1]];

    // Reformat the date
    const formattedDate = `${parts[2]}-${month}-${parts[0]}`;

    return formattedDate;
  }

  const reverseDate = (date) => {
    if (date) {
      return date.toString().split("-").reverse().join("-");
    } else {
      return "";
    }
  };

  const HandleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.put(
        `/dashboard/project-candidates/${projectId}`,
        { candidate: [changedValues] },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status == 200) {
        setLoading(false);
        setArrayValues(res.data.data, setCandidateListData);
        ResetFilter();
        dispatch(setAppError({ msg: res.data.message, color: "success" }));
        setShowPromptElement(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      if (error?.response?.data?.message) {
        dispatch(setAppError({ msg: error?.response?.data?.message }));
      } else {
        dispatch(setAppError({ msg: error?.message }));
      }
    }
  };
  useEffect(() => {
    if (showPromptElement?.editData) {
      const data = showPromptElement?.editData;
      const selectionDate = formatDate(data?.selection_date);
      const dobDate = formatDate(data?.visa_stamping_date);
      const issuedDate = formatDate(data?.passport_issue_date);
      const expiryDate = formatDate(data?.passport_expiry_date);
      setSector(data?.visa_block_number);
      setNationality(data?.visa_profession_id);
      setReligion(data?.religion);
      setDate(selectionDate);
      setRemark(data?.approval_remark);
      setActualPosition(data?.job_position_id);
      setDob(dobDate);
      setAge(Number(data?.age));
      setGrade(data?.selection_grade);
      setBasic(Number(data?.basic));
      setFood(Number(data?.food));
      setFixedOt(Number(data?.fixed_ot));
      setHra(Number(data?.hra));
      setTravelAllowance(Number(data?.travel_allowance));
      setMobileAllowance(Number(data?.mobile_allowance));
      setAirTicketAllowance(Number(data?.air_ticket_allowance));
      setAdditonalOt(Number(data?.additional_ot));
      setOtherAllowance(Number(data?.other_allowance));
      setDutyHours(Number(data?.duty_hours));
      setFixedOtHours(Number(data?.fixed_ot_hours));
      setContractDuration(data?.duration_of_contract);
      setProbationPeriod(data?.probation_period);
      setPassportIssueDate(issuedDate);
      setPassportExpiryDate(expiryDate);
      setEmergencyContactPerson(data?.emergency_contact_person_in_home_country);
      setEmergencyContactNumber(
        Number(data?.emergency_contact_number_in_home_country)
      );
      setCovidVaccine(data?.covid_vaccine);
      setBloodGroup(data?.blood_group);
      setPassportNumber(data?.passport_number);
      setName(data?.visa_reference_number);
      setComments(data?.visa_cancelled_comments);
      if (updateVisaDetails) {
        setVisaRefferenceNumber(
          data?.visa_reference_number ? data?.visa_reference_number : ""
        );
        setVisaRefferenceNumberValidation(
          data?.visa_reference_number ? data?.visa_reference_number : ""
        );
        setVisaBlockNumber(data?.visa_block_number);
      }
      setStatus(data?.status);
    }
  }, []);
  useEffect(() => {
    validation();
  },[changedValues]);
  const validation = () => {
    setDisabled(false)
    const data = showPromptElement?.editData;
    const selectionDate = formatDate(data?.selection_date);
    const dobDate = formatDate(data?.visa_stamping_date);
    const issuedDate = formatDate(data?.passport_issue_date);
    const expiryDate = formatDate(data?.passport_expiry_date);
    console.log(updateVisaDetails,"adfasdf");
    if (updateVisaDetails) {
      if (
        (data.visa_block_number == sector &&
        data?.visa_profession_id == nationality &&
        data?.religion == religion &&
        selectionDate == date &&
        data?.approval_remark == remark &&
        data?.job_position_id == actualPosition &&
        dobDate == dob &&
        data?.age == age &&
        data?.selection_grade == grade &&
        data?.basic == basic &&
        data?.food == food &&
        data?.fixed_ot == fixedOt &&
        data?.hra == hra &&
        data?.travel_allowance == travelAllowance &&
        data?.mobile_allowance == mobileAllowance &&
        data?.air_ticket_allowance == airTicketAllowance &&
        data?.additional_ot == additonalOt &&
        data?.other_allowance == OtherAllowance &&
        data?.duty_hours == dutyHours &&
        data?.fixed_ot_hours == fixedOtHours &&
        data?.duration_of_contract == contractDuration &&
        data?.probation_period == ProbationPeriod &&
        issuedDate == passportIssueDate &&
        expiryDate == passportExpiryDate &&
        data?.emergency_contact_person_in_home_country ==
          emergencyContactPerson &&
        data?.emergency_contact_number_in_home_country ==
          emergencyContactNumber &&
        data?.covid_vaccine == covidVaccine &&
        data?.blood_group == bloodGroup &&
        data?.passport_number == passportNumber &&
        data?.visa_reference_number == name &&
        VisaRefferenceNumberValidation == VisaRefferenceNumber &&
        data?.visa_block_number == VisaBlockNumber &&
        data?.status == status)||!nationality
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    } else {
      if (
        data.visa_block_number == sector &&
        data?.visa_profession_id == nationality &&
        data?.religion == religion &&
        selectionDate == date &&
        data?.approval_remark == remark &&
        data?.job_position_id == actualPosition &&
        dobDate == dob &&
        data?.age == age &&
        data?.selection_grade == grade &&
        data?.basic == basic &&
        data?.food == food &&
        data?.fixed_ot == fixedOt &&
        data?.hra == hra &&
        data?.travel_allowance == travelAllowance &&
        data?.mobile_allowance == mobileAllowance &&
        data?.air_ticket_allowance == airTicketAllowance &&
        data?.additional_ot == additonalOt &&
        data?.other_allowance == OtherAllowance &&
        data?.duty_hours == dutyHours &&
        data?.fixed_ot_hours == fixedOtHours &&
        data?.duration_of_contract == contractDuration &&
        data?.probation_period == ProbationPeriod &&
        issuedDate == passportIssueDate &&
        expiryDate == passportExpiryDate &&
        data?.emergency_contact_person_in_home_country ==
          emergencyContactPerson &&
        data?.emergency_contact_number_in_home_country ==
          emergencyContactNumber &&
        data?.covid_vaccine == covidVaccine &&
        data?.blood_group == bloodGroup &&
        data?.passport_number == passportNumber &&
        data?.visa_reference_number == name &&
        data?.status == status
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
  };

  const statusForupdateFlightDetails = [
    "VISA STAMPED",
    // "VISA CANCELLED REQUIREMENT FULFILLED",
    "VISA CANCELLED",
  ];

  const [visaBlockData, setVisaBlockData] = useState();


  const [isChecked, setChecked] = useState(false);

  const handleCheckboxChange = () => {
    setChecked(!isChecked);
  };


  useEffect(() => {
    const uniqueVisasByBlock = {};
  
    // Iterate through project_visa array
    candidateListData?.project_visa?.forEach((visa) => {
      const visaBlockNumber = visa?.vrf_visa?.visa_block_number;
  
      // Check if block_number already exists in uniqueVisasByBlock
      if (!uniqueVisasByBlock[visaBlockNumber]) {
        // If not, add the current visa as an array with visa_profession
        uniqueVisasByBlock[visaBlockNumber] = {
          ...visa.vrf_visa,
          ...visa,
          vrf_visa: {
            ...visa.vrf_visa,
            visa_professions: [visa.vrf_visa.visa_profession],
          },
        };
      } else {
        // If block_number already exists, add visa_profession to the array
        uniqueVisasByBlock[visaBlockNumber].vrf_visa.visa_professions.push(
          visa.vrf_visa.visa_profession
        );
      }
    });
  
    // Step 2: Convert the values of the uniqueVisasByBlock object to an array
    const uniqueVisas = Object.values(uniqueVisasByBlock);
    setUniqueVisaBlock(uniqueVisas);
  }, []);
  


  useEffect(() => {
    if (uniequVisaBlock ) {
      const projectVisaArray = uniequVisaBlock;

      const matchingProjectVisa = projectVisaArray.find(
        (visa) => visa.vrf_visa.visa_block_number == sector
      );

      if (matchingProjectVisa) {
        setVisaBlockData(matchingProjectVisa);
        // setFinalObj((prevState) => ({
        //   ...prevState,
        //   visa_profession_id: matchingProjectVisa.vrf_visa.visa_profession.id,
        // }));
      } else {
        console.log("No matching project_visa found for sector ID");
      }
    }
  }, [candidateListData,sector]);

console.log(visaBlockData,"visablockdata");


  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen  bg-black/50 justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="w-full relative max-w-md   h-[500px] overflow-y-auto uppercase min-h-[14rem] rounded-md bg-white/90">
        <form
          onSubmit={HandleFormSubmit}
          className="flex flex-col gap-3 px-2 py-3"
        >
          <div className="flex justify-between  items-center">
            <h2 className="block text-lg text-left font-bold text-gray-700 ">
              Edit Candidate
            </h2>
            <AiFillCloseCircle
              className="cursor-pointer"
              size={"1.4rem"}
              onClick={() => {
                setShowPromptElement(false);
              }}
            />
          </div>
          <div className=" p-4  text-center flex justify-center flex-col">
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                VISA BLOCK NUMBER
              </label>
              <select
                value={sector}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setSector(e.target.value);
                  setNationality(null)
                  if (
                    String(showPromptElement?.editData?.visa_block_number) !==
                      String(e.target.value) &&
                    e.target.value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      visa_block_number: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("visa_block_number" in copiedObg) {
                      delete copiedObg["visa_block_number"];
                    }
                  }
                }}
                required
              >
                <option value={""} hidden></option>
                {uniequVisaBlock?.map((item) => (
                  <option
                    value={item.vrf_visa.visa_block_number}
                    key={item.vrf_visa.visa_block_number}
                  >
                    {item.vrf_visa.visa_block_number}
                  </option>
                ))}
              </select>
            </div>

            {visaBlockData && (
              <div className="mb-3">
  <label className="block text-left mb-1 text-sm">
    VISA PROFESSION
  </label>
  <select
    defaultValue={showPromptElement?.editData?.visa_profession_id || ""}
    className="select select-bordered select-sm w-full"
    onChange={(e) => {
      setNationality(e.target.value);
      if (
        String(showPromptElement?.editData?.visa_profession_id) !==
        String(e.target.value) &&
        e.target.value !== ""
      ) {
        setChangedValues((prevValues) => ({
          ...prevValues,
          visa_profession_id: e.target.value,
        }));
      } else {
        const copiedObg = changedValues;
        if ("visa_profession_id" in copiedObg) {
          delete copiedObg["visa_profession_id"];
        }
      }
    }}
    required
  >
    <option value="" hidden>
      Select an option
    </option>
    {visaBlockData.vrf_visa.visa_professions?.map((item) => (
      <option
        value={item.id}
        key={item.id}
      >
        {item.name}
      </option>
    ))}
  </select>
</div>

)}

            {/* {visaBlockData && <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                VISA PROFESSION
              </label>
              <input
                value={visaBlockData ? visaBlockData.vrf_visa.visa_profession.name : ""}
                className="uppercase input-sm w-full input input-bordered"
                type="text"
              />
            </div>} */}
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                VISA REFERENCE NO
              </label>
              <input
                value={name}
                className="uppercase input-sm w-full input input-bordered"
                type="text"
                name="visa_reference_number"
                placeholder="Reference No"
                onChange={(e) => {
                  const value = e.target.value;
                  setName(value);
                  if (
                    showPromptElement?.editData?.visa_reference_number !=
                      value &&
                    value != ""
                  ) {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      visa_reference_number: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("visa_reference_number" in copiedObg) {
                      delete copiedObg["visa_reference_number"];
                    }
                  }
                }}
                required
              />
            </div>
            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">
                VISA STAMPING DATE
              </label>
              <input
                value={dob}
                className="uppercase input-sm w-full input input-bordered"
                type="date"
                onChange={(e) => {
                  setDob(e.target.value);
                  const date = formatDate(
                    showPromptElement?.editData?.visa_stamping_date
                  );
                  if (date != e.target.value && e.target.value != "") {
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      visa_stamping_date: reverseDate(e.target.value),
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("visa_stamping_date" in copiedObg) {
                      delete copiedObg["visa_stamping_date"];
                    }
                  }
                }}
              />
            </div>

            <div className="mb-3">
              <label className="block text-left mb-1 text-sm">STATUS</label>
              <select
                value={status}
                className="select select-bordered select-sm w-full"
                onChange={(e) => {
                  setStatus(e.target.value);
                  if (
                    String(showPromptElement?.editData?.status) !==
                      String(e.target.value) &&
                    e.target.value != ""
                  ) {
                    setStatus(e.target.value)
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      status: e.target.value,
                    }));
                  } else {
                    const copiedObg = changedValues;
                    if ("status" in copiedObg) {
                      delete copiedObg["status"];
                    }
                  }
                }}
                required
              >
                <option value={""} hidden></option>
                {statusForupdateFlightDetails?.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            {status == "VISA CANCELLED" && (
              <div className="mb-3">
                <label className="block text-left mb-1 text-sm">COMMENTS</label>
                <textarea
                  value={comments}
                  rows={2}
                  className="input-sm w-full input input-bordered"
                  type="text"
                  name="visa_cancelled_comments"
                  placeholder="Add Your Comments"
                  onChange={(e) => {
                    setComments(e.target.value)
                    setChangedValues((prevValues) => ({
                      ...prevValues,
                      visa_cancelled_comments: e.target.value,
                    }));
                  }}
                  required
                />
              </div>
            )}

            {status == "VISA CANCELLED" && (
              <div>
                <div style={{ display: "flex" }}>
                  <input
                    required
                    style={{ width: "2rem" }}
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <span
                    style={{ marginLeft: "1rem" }}
                    className="block text-left mb-1 text-sm"
                  >
                    Are you sure if the details have been removed from ENJAZ
                    Portal
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="flex gap-3  m-5 justify-center items-center">
            <button
              className="p-1 w-full uppercase rounded-md ring-1 ring-slate-600"
              disabled={loading}
              onClick={() => {
                setShowPromptElement(false);
              }}
            >
              Cancel
            </button>
            <button
              className="p-1 w-full uppercase rounded-md ring-1 ring-red disabled:bg-rose-400 text-white bg-red"
              type="submit"
              disabled={loading || disabled}
            >
              {loading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
